<template>
  <div class="history">
    <div
      id="history"
      class="history-section"
    >
      <div class="mobile">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2
                class="banner-text"
                v-html="page.acf.history_header"
              />
              <hr>
            </div>
            <div class="col-12 year-container">
              <div class="sub-text">
                <p
                  class="sub-text"
                  v-text="page.acf.history_sub_text"
                />
              </div>
              <div class="years">
                <span class="year">1</span><span class="year">7</span>
                <p>Years</p>
              </div>
            </div>
          </div>

          <div class="row stats">
            <div class="col-12">
              <div class="number">
                {{ page.acf.history_awards }}
              </div>
              <div class="line" />
              <div class="text">
                Grants<br>Awarded
              </div>
            </div>
            <div class="col-12">
              <div class="number">
                ${{ page.acf.history_grants }} million
              </div>
              <div class="line" />
              <div class="text">
                In Awarded<br>Grants
              </div>
            </div>
            <!-- <div class="col-12">
              <div class="number">
                {{ page.acf.history_votes }} million
              </div>
              <div class="line" />
              <div class="text">
                Votes Cast
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="desktop">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2
                class="banner-text"
                v-html="page.acf.history_header"
              />
              <hr>
            </div>
            <div class="col-12 year-container">
              <div class="sub-text">
                <p
                  class="sub-text"
                  v-text="page.acf.history_sub_text"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6 stats">
              <div class="col-12">
                <div class="number">
                  {{ page.acf.history_awards }}
                </div>
                <div class="line" />
                <div class="text">
                  Grants<br>Awarded
                </div>
              </div>
              <div class="col-12">
                <div class="number">
                  ${{ page.acf.history_grants }} million
                </div>
                <div class="line" />
                <div class="text">
                  In Awarded<br>Grants
                </div>
              </div>
              <!-- <div class="col-12">
                <div class="number">
                  {{ page.acf.history_votes }} million
                </div>
                <div class="line" />
                <div class="text">
                  Votes Cast
                </div>
              </div> -->
            </div>

            <div class="col-6 years">
              <span class="year">1</span><span class="year">7</span>
              <p>Years</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="mobile">

    <div
      id="overview"
      class="overview-section"
    >
      <div class="container">
        <div class="row overview-content">
          <div class="col-9">
            <div class="horizontal-scroll">
              <a
                class="btn light small"
                @click="setMission"
                @keypress="setMission"
              >
                Program Mission
              </a>
              <a
                class="btn light small"
                @click="setGrants"
                @keypress="setGrants"
              >
                Grants
              </a>
              <a
                class="btn light small"
                @click="setParticipation"
                @keypress="setParticipation"
              >
                Participation
              </a>
            </div>
            <article v-html="overviewText" />
          </div>
          <div class="col-3 desktop">
            <RysResponsiveImage
              :img="overviewImage"
              class="desktop"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yoastToVueMeta from '@/utils/yoast-to-vue-meta';

export default {
  name: 'RysCampusImprovementProgramHistory',

  async setup() {
    const wpJson = useWp();

    const { data: page, error: pageError } = await useAsyncData(
      'page-program-history',
      () => wpJson.pages.getBySlug('program-history')
    );

    if (pageError.value) {
      throw createError({ status: 500, cause: pageError.value });
    }

    if (!page.value) {
      throw createError({ statusCode: 404 });
    }

    return { page };
  },

  data() {
    return {
      text: false,
      image: false
    };
  },

  head() {
    return yoastToVueMeta(this.page);
  },

  computed: {
    overviewText() {
      return this.text || this.page.acf.mission_text;
    },
    overviewImage() {
      return this.image || this.page.acf.mission_image;
    }
  },

  methods: {
    setMission() {
      this.text = this.page.acf.mission_text;
      this.image = this.page.acf.mission_image;
    },

    setGrants() {
      this.text = this.page.acf.grants_text;
      this.image = this.page.acf.grants_image;
    },

    setParticipation() {
      this.text = this.page.acf.participation_text;
      this.image = this.page.acf.participation_image;
    }
  }
};
</script>

<style lang="scss" scoped>
.overview-section {
  margin: 36px 0;

  h2 {
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    text-transform: uppercase;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 80px;
      line-height: 80px;
    }
  }

  .overview-content {
    @media screen and (min-width: $breakpoint-sm) {
      background: $thd-off-white;
      padding: 36px 50px 70px;
    }
  }

  .btn.small {
    margin: 0 16px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  & + hr {
    width: 90%;
    border: 0.5px solid $thd-cool-gray;
    margin: 60px auto 30px;
  }
}

.history-section {
  margin-bottom: 36px;

  h2::v-deep {
    font-size: 48px;
    line-height: 48px;
    font-weight: 700;
    text-transform: uppercase;

    @media screen and (min-width: $breakpoint-lg) {
      font-size: 80px;
      line-height: 80px;
    }

    strong {
      color: $thd-orange;
    }
  }

  hr {
    width: 60px;
    color: $thd-tan;
    margin: 0;
  }

  .sub-text {
    font-size: 18px;
    line-height: 24px;
  }

  .year-container {
    display: flex;
    justify-content: space-between;
  }

  .years {
    text-align: center;
    flex-shrink: 0;

    .year {
      font-size: 72px;
      line-height: 64px;
      font-weight: 700;
      background: $thd-black;
      color: $thd-white;
      display: inline-block;
      margin: 0 7px;
      padding: 18px;
    }

    p {
      color: $thd-cool-gray;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 0.2em;
      font-size: 12px;
      line-height: 12px;
      margin: 8px 0 0;
    }
  }

  .stats {
    margin-top: 40px;

    .col-12 {
      display: flex;
      justify-content: stretch;
      margin-bottom: 20px;

      .text {
        color: $thd-cool-gray;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 0.2em;
        font-size: 12px;
        line-height: 12px;
        display: flex;
        align-items: flex-end;
        text-align: right;
      }

      .line {
        border-bottom: 1px solid $thd-tan;
        flex-grow: 1;
        margin: 0 12px;
      }

      .number {
        font-size: 28px;
        line-height: 32px;
        font-weight: 700;
        font-stretch: condensed;
      }
    }
  }

  .desktop {
    .sub-text {
      line-height: 28px;
    }

    .years {
      margin-top: 40px;

      .year {
        font-size: 162px;
        line-height: 162px;
        padding: 48px;
      }

      p {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .stats {
      margin-top: 80px;

      .col-12 {
        margin-bottom: 40px;

        .text {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
